import React from 'react'
import { useQuery } from 'react-query'
import { indexBy, path, pathOr, prop } from 'ramda'
import { ICountry } from './options.type'

export const useCountries = (query?: any) => {
  const { data, isLoading, refetch } = useQuery<ICountry | undefined>(['/options/countries'], {
    select: data => path(['data'], data),
  })

  const byId: any = React.useMemo(() => {
    return indexBy(prop('code'), pathOr([], ['countryInfos'], data))
  }, [data])

  return { data, isLoading, refetch, byId }
}
